import { Chip, TextField, Tooltip } from '@mui/material';
import React from 'react';

const getMoreDetails = (unit) => (unit ? `(${unit})` : '');

const defaultAutocompleteProps = {
  id: 'autocomplete-multiple',
  limitTags: 100,
  multiple: true,
  disableCloseOnSelect: true,
  renderInput: (params) => <TextField {...params} size="small" label="Датчики" variant="outlined" />,
  renderTags: (value, getTagProps) =>
    value.map(({ sensorTypeId, description, units, name }, index) => (
      <Tooltip key={sensorTypeId} title={description || 'Нет данных'} placement="bottom-start" arrow>
        <Chip
          label={`${name} ${getMoreDetails(units)}`}
          {...getTagProps({ index })}
          key={sensorTypeId}
          color="primary"
          size="small"
          sx={{ margin: 0.5 }}
        />
      </Tooltip>
    )),
  getOptionLabel: (option) => `${option.name} ${getMoreDetails(option.units)}`,
};

export default defaultAutocompleteProps;
